<template>
	<div class="cruiseOrderDetail">
		<back-to></back-to>
		<section class="cruiseOrderDetail-con">
			<div class="cruiseOrderDetail-con_info">
				<span class="cruiseOrderDetail-con_infot">{{all.productName}}</span>
				<span class="cruiseOrderDetail-con_infoc">
					<label for="">
						<p>
							<font>舱型</font>
							<font>{{all.cabinName}}</font>
						</p>
						<p>
							<font>出发日期</font>
							<font>{{all.sendDate | formateDate}}</font>
						</p>
						<p>
							<font>人数</font>
							<font>成人×{{all.num}}</font>
						</p>
					</label>
					<img :src="all.productImage" alt="">
				</span>
				<span class="cruiseOrderDetail-con_infob">
					<p>{{all.orderStatusName}}</p>
				</span>
			</div>
			<div class="cruiseOrderDetail-con_common">
				<h2>订单详情</h2>
				<span class="cruiseOrderDetail-con_commonl">
					<label for="">
						<font>订单号</font>
						<p>{{all.orderNo}}</p>
					</label>
					<label for="">
						<font>团期</font>
						<p>{{all.tour_no}}</p>
					</label>
					<label for="">
						<font>下单时间</font>
						<p>{{all.orderDate|formateDate}}</p>
					</label>
					<label for="">
						<font>出发地</font>
						<p>{{all.departure}}</p>
					</label>
					<label for="">
						<font>目的地</font>
						<p>{{all.destination}}</p>
					</label>
				</span>
				<span class="cruiseOrderDetail-con_commonb">
					<font>订单金额</font>
					<p><b>￥</b>{{all.price}}</p>
				</span>
			</div>
			<div class="cruiseOrderDetail-con_common">
				<h2>订单联系人</h2>
				<span class="cruiseOrderDetail-con_commonl">
					<label for="">
						<font>姓名</font>
						<p>{{all.contract}}</p>
					</label>
					<label for="">
						<font>电话</font>
						<p>{{all.tel}}</p>
					</label>
				</span>
			</div>
			<div class="cruiseOrderDetail-con_common">
				<h2>出行人信息</h2>
				<div class="person_infoma">
					<span class="person_infoma-item" v-for="(item,index) in all.guest" :key="index">
						<label for="" class="left-ar">
							<div class="left-ara">
								<label for="">
									<p>{{item.name}}</p>
									<font>成人</font>
								</label>
								<p v-if="item.id_card != ''">身份证：{{item.id_card}}</p>
							</div>
						</label>
						<img class="right-ar" src="../../assets/ico_ar.png" alt="">
					</span>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	import {
		formatTime
	} from '@/config/util'
	export default {
		name: 'cruiseOrderDetail',
		components: {
			BackTo
		},
		data() {
			return {
				all: ""
			}
		},
		filters: {
			formateDate(time) {
				let date = new Date(time)
				return formatTime(date)
			}
		},
		created() {

		},
		mounted() {
			this.getOrderInfo()
		},
		methods: {
			getOrderInfo() {
				var jsonData = {
					orderId: this.$route.query.orderId
				}
				this.$get(
					this.$domainUrl + '/ShipApp/GetShipOrderDetail', jsonData
				).then(res => {
					this.all = res.data
				})
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		}
	}
</script>

<style scoped>
	.cruiseOrderDetail-con {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
		padding-bottom: 60px;
	}

	.cruiseOrderDetail-con_info {
		width: 100%;
		border-radius: 16px;
		background-color: #fff;
		padding: 20px 30px;
		box-sizing: border-box;
	}

	.cruiseOrderDetail-con_infot {
		width: 100%;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #EEEEEE;
		padding-bottom: 20px;
	}

	.cruiseOrderDetail-con_infoc {
		padding: 20px 0;
		display: flex;
		justify-content: space-between;
	}

	.cruiseOrderDetail-con_infoc img {
		width: 173px;
		height: 173px;
		border-radius: 10px;
		margin-left: 14px;
	}

	.cruiseOrderDetail-con_infoc label {
		height: 173px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

	}

	.cruiseOrderDetail-con_infoc p {
		font-size: 28px;
		color: #36393E;
	}

	.cruiseOrderDetail-con_infoc p font:first-child {
		display: inline-block;
		color: #999999;
		width: 124px;
	}

	.cruiseOrderDetail-con_infob {
		padding-top: 20px;
		border-top: 1px solid #EEEEEE;
		display: flex;
	}

	.cruiseOrderDetail-con_infob p {
		height: 40px;
		position: relative;
		border-radius: 3px;
		border: 1px solid #FFC08A;
		font-size: 24px;
		color: #FF7A09;
		margin-right: 20px;
		padding: 0 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 3px;
	}

	.cruiseOrderDetail-con_common {
		margin-top: 20px;
		width: 100%;
		border-radius: 16px;
		background-color: #fff;
		padding: 20px 30px;
		box-sizing: border-box;
	}

	.cruiseOrderDetail-con_common h2 {
		font-size: 32px;
		color: #36393E;
		width: 100%;
		padding-bottom: 20px;
	}

	.cruiseOrderDetail-con_commonl {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	.cruiseOrderDetail-con_commonl label {
		display: flex;
		align-items: center;
		padding-bottom: 20px;
	}

	.cruiseOrderDetail-con_commonl label font {
		width: 114px;
		font-size: 28px;
		color: #999999;
	}

	.cruiseOrderDetail-con_commonl label p {
		font-size: 28px;
		color: #333333;
		margin-left: 40px;
	}

	.cruiseOrderDetail-con_commonb {
		display: flex;
		align-items: center;
		padding-top: 30px;
		border-top: 1px solid #F1F3F5;
	}

	.cruiseOrderDetail-con_commonb label {
		display: flex;
		align-items: center;
	}

	.cruiseOrderDetail-con_commonb font {
		font-size: 28px;
		color: #999999;
	}

	.cruiseOrderDetail-con_commonb p {
		font-size: 40px;
		color: #F94C00;
		margin-left: 24px;

	}

	.cruiseOrderDetail-con_commonb b {
		font-size: 30px;
		color: #F94C00;
		font-weight: normal;
	}

	.person_infoma {
		width: 100%;
		background: #F8F8F8;
		border-radius: 12px;
		display: flex;
		flex-direction: column;
	}

	.right-ar {
		width: 12px;
		height: 22px;
	}

	.person_infoma-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 30px 20px;
		box-sizing: border-box;
	}

	.left-ar {
		display: flex;
		align-items: center;
	}

	.left-ara {
		padding-left: 30px;
	}

	.left-ara label {
		display: flex;
		align-items: center;
	}

	.left-ara p {
		font-size: 24px;
		color: #999999;
		padding-top: 14px;
	}

	.left-ara label p {
		font-size: 28px;
		color: #333333;
		margin-right: 16px;
		padding: 0;
	}

	.left-ara label font {
		width: 76px;
		height: 36px;
		border-radius: 3px;
		border: 2px solid #FF7A09;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #FF7A09;
	}
</style>
